<div *ngIf="cardInfo() as cardInfo">
  <crm-collapsible-section [maxHeightPx]="100">
    <span class="note">{{ cardInfo.body }}</span>
  </crm-collapsible-section>
  <div class="row">
    <ng-container
      [ngTemplateOutlet]="activityData"
      [ngTemplateOutletContext]="{ label: 'ACTIVITY.COMMUNICATION.TYPE', value: cardInfo.channel }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="activityData"
      [ngTemplateOutletContext]="{ label: 'ACTIVITY.OUTCOME', value: cardInfo.outcome }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="activityData"
      [ngTemplateOutletContext]="{ label: 'ACTIVITY.DATE', value: cardInfo.date | date : dateFormat }"
    ></ng-container>
  </div>
</div>

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-4">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      <ng-container *ngIf="value">
        {{ value }}
      </ng-container>
    </div>
  </div>
</ng-template>
